export class ProductsAvailabilityDto {
    all: number;
    active: number;
    inactive: number;
}
